<div class="unsuccessful-snackbar-wrapper">
  <div class="content-wrapper">
    <i class="error-icon"></i>
    <div class="text-wrapper">
      <span class="main-text">Failed</span>
      <span class="supporting-text" *ngIf="data"></span>
    </div>
  </div>

  <mat-icon (click)="closeSnackBar()">close</mat-icon>
</div>
